import React from 'react'
import { request } from '../helpers/request'
import { t } from '../helpers/translate.js'
import Immutable from 'immutable'
import LoadingComponent from './common/LoadingComponent'
import ModalComponent from './common/ModalComponent';
import ListingComponent from './common/ListingComponent'
import PagerComponent from './common/PagerComponent'
import LimitComponent from './common/LimitComponent'
import SearchboxComponent from './common/SearchboxComponent';
import { isAgent } from '../helpers/access'
import { Button } from 'react-bootstrap'
import Icon from 'react-fa'

let config = require('config');

class BulkUploadList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sources: (this.props.location.query.sources || 'all').split(','),
      insurer: this.props.location.query.insurer || 'all',
      allsources: [],
      loading: false,
      showModal: false,
      uploadLists: [],
      criteria: this.getSearchType() && this.getCriteriaFromQuery(this.props.location.query),
      page: this.props.location.query.page || 1,
      limit: this.props.location.query.limit || 10,
      orderby: this.props.location.query.orderby || 'created_at',
      order: this.props.location.query.order || 'desc',
      displayListsData: null,
      displayDetailsData: null,
      uploadDetails: [],
      org: sessionStorage.getItem('org'),
    };
  }

  getCriteriaKeys() {
    return config.default.search[this.props.route.searchType][sessionStorage.getItem('org')].map((field) => field.key)
  }

  getSearchType() {
    return this.props.route.searchType === 'bulkuploadlist'
  }

  componentWillMount() {
    this.loadSourceData();
    this.getUploadList(this.props.location.query);
  }

  getCriteriaFromQuery(query) {
    let criteriaKeys = this.getCriteriaKeys();
    let criteria = Immutable.Map({});

    for (let key of criteriaKeys) {
      if (query[key]) {
        criteria = criteria.set(key, query[key]);
      }
    }
    return criteria.toObject();
  }

  componentWillReceiveProps(newProps) {
    this.getUploadList(newProps.location.query);
  }

  showModal(title, body, resetDataOnClose = true) {
    this.setState({
      showModal: true,
      modalBody: t(body),
      modalTitle: t(title),
      resetDataOnClose: resetDataOnClose
    })
  }

  setListCriteria(query) {
    if (this.getSearchType()) {
      this.state.criteria = this.getCriteriaFromQuery(query);
    }
    this.state.limit = query.limit || '10';
    this.state.page = query.page || '1';
    this.state.orderby = query.orderby || 'created_at';
    this.state.order = query.order || 'desc';
  }

  getPage() {
    return this.state.page
  }

  getLimit() {
    return this.state.limit
  }

  getOrderBy() {
    return this.state.orderby
  }

  getOrder() {
    return this.state.order
  }

  getRequestBody() {
    if (this.getSearchType() && _.isEmpty(this.state.criteria.sources)) {
      this.state.criteria.sources = 'all';
    }

    let requestBody = {
      criteria: this.state.criteria,
      page: this.getPage(),
      limit: this.getLimit(),
      orderby: this.getOrderBy(),
      order: this.getOrder(),
      org: this.state.org
    };

    this.getSearchType() && (requestBody.criteria.org = sessionStorage.getItem('org'));

    return requestBody
  }

  loadSources(responseData, statusCode) {
    if (statusCode == 200) {
      let temp_sources = [{ value: 'all', text: 'All Products' }];

      if (!isAgent('ingle')) {
        responseData.sources.forEach(function (source) {
          if ((config.default.clients[source.name] !== undefined) && source.active) {
            temp_sources.push({
              value: source.name,
              text: `${source.full_name} ${source.category}`
            });
          }
        });
      }

      this.setState({
        allsources: responseData.sources
      });

      this.setSources(this.state.insurer);
    }
  }

  loadUploadData(responseData, status) {
    if (status == 200) {
      this.setState({
        uploadDetails: responseData,
        loading: false,
        displayDetailsData: this.handleDetailsData(responseData)
      })
    } else {
      this.showModal(t('Error'), t('Unable to get application data'));
    }
  }

  getUploadList = (query) => {
    if (_.isEmpty(query)) {
      return
    }

    this.setListCriteria(query)
    this.setState({
      loading: true,
    });

    request(`${config.default.api}/bulkuploadlist`,
      'POST', this.getRequestBody(),
      function (responseData, status) {
        if (status == 200) {
          this.setState({
            uploadLists: responseData,
            loading: false,
            displayListsData: this.handleListsData(responseData)
          })
        } else {
          this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>));
        }
      }.bind(this)
    );
  }

  loadSourceData() {
    this.setState({ loading: true });
    $.when(request(
      `${config.default.api}/sources/`, 'GET', null, this.loadSources.bind(this))
    ).done(this.setState({ loading: false }));
  }

  setInsurer(val) {
    this.setState({ insurer: val })
    this.setSources(val)
  }

  setSources(insurer) {
    let tempSources = [{ value: 'all', text: 'All' }];

    this.state.allsources.forEach(function (source) {
      const oneSource = {
        value: source.name,
        text: `${source.full_name} ${source.category}`
      }

      const sourcename = config.default.clients[source.name];
      if ((sourcename !== undefined) && source.active && sourcename.upload_path[0].canUpload === true) {
        if ((insurer == 'all') || (insurer == source.insurer)) {
          tempSources.push(oneSource);
        }
      }
    });

    this.setState({ sources: tempSources });
  }

  base64ToUint8Array (base64Data) {
    const cleanBase64 = base64Data.split(',').pop();
    const binaryString = atob(cleanBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  regenerateResultsEmail(uploadId, walletCard = false) {
    this.setState({ loading: true });
    if (walletCard) {
      request(`${config.default.api}/walletcardzip/${uploadId}`,
        'GET', null,
        function (responseData, status) {
          if (status == 200) {
            this.setState({ loading: false });

            const base64str = responseData.zipfile;
            const bytes = this.base64ToUint8Array(base64str);
            const blob  = new Blob([bytes], { type: 'application/zip' });
            const url = URL.createObjectURL(blob);
            const a   = document.createElement('a');
            a.href     = url;
            a.download = `walletcards_${uploadId}.zip`;
            a.click();
            URL.revokeObjectURL(url);

          } else {
            this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>));
          }
        }.bind(this)
      );
      return;
    }
    request(`${config.default.api}/regeneratepdfs/${uploadId}`,
      'GET', null,
      function (responseData, status) {
        if (status == 200) {
          this.setState({ loading: false });
          this.showModal(t('Success'), t('An Email will be sent shortly with the results'));
        } else {
          this.showModal(t('Error'), responseData.messages.map((message) => <p>{message}</p>));
        }
      }.bind(this)
    );
  }

  handleModalClose() {
    this.setState({
      showModal: false,
    })
  }

  getPagerComponent(total) {
    return <div className="col-sm-12 div-center">
      <PagerComponent page={this.getPage()} limit={this.getLimit()} total={total} />
    </div>
  }

  handleListsData(data) {
    return <div id="results" name="results" className="col-lg-10">
      <div className="row">
        <div className="col-sm-9">
          <div className="form-control-static"><b>{t('Number of Results:')} {data.total}</b></div>
        </div>
        <div className="col-sm-3"><LimitComponent currentLimit={this.getLimit()}
        /></div>
      </div>
      <div className="row">
        {this.getPagerComponent(data.total)}
        <div className="clearfix"></div>
        <br />
        <ListingComponent
          config={config.default.bulkuploadlist[sessionStorage.getItem('org')]}
          dataArray={data.lists}
          endpoint='bulkuploadlist'
          searchType={this.props.route.searchType}
          page={this.getPage()} limit={this.getLimit()}
          orderby={this.getOrderBy()} order={this.getOrder()}
          regenerateResultsEmail={this.regenerateResultsEmail.bind(this)}
          showModal={this.showModal.bind(this)}
        />
        {this.getPagerComponent(data.total)}
      </div>
    </div>
  }

  handleDetailsData(data) {
    const list = data.lists[0];
    data.lists['policies'].map(policy => policy.source = list.source);
    return <div>
      <div className="text-center page-title form-btn">
        <h3 className='form-padding'>{`${list.source_name} ${list.source_category}`}</h3>
        <h4>{t('Uploader')}: {list.uploader}</h4>
      </div>
      <div id="results" name="results" className="col-lg-10">
          <button className="btn button-secondary button-minor" onClick={() => { window.history.go(-this.state.count) }}>
            <Icon name="chevron-left" /> {t('Return to Search Results')}
          </button>
        <div className="row">
          <div className="col-sm-9">
            <div className="form-control-static"><b>{t('Number of Results:')} {data.total}</b></div>
          </div>
          <div className="col-sm-3"><LimitComponent currentLimit={this.getLimit()}
          /></div>
        </div>
        <div className="row">
          {this.getPagerComponent(data.total)}
          <div className="clearfix"></div>
          <br />
          <ListingComponent
            config={config.default.uploaddetails[sessionStorage.getItem('org')]}
            dataArray={data.lists['policies']}
            endpoint='uploaddetails'
            searchType={this.props.route.searchType}
            page={this.getPage()} limit={this.getLimit()}
            orderby={this.getOrderBy()} order={this.getOrder()}
          />
          {this.getPagerComponent(data.total)}
        </div>
        {data.lists['policies'].length > 0 && <div className="div-container landing-page-layout div-center">
          <Button onClick={() => this.regenerateResultsEmail(list.bulk_upload_id)} className="btn button-secondary button-minor">{t('Send Results Email')}</Button>
          {((list['option']).includes('zip')) ? <Button onClick={() => this.regenerateResultsEmail(list.bulk_upload_id, true)} className="btn button-secondary button-minor">{t('Download Wallet Cards')}</Button> : null}

        </div>}
      </div>
    </div>
  }

  getPageTitle() {
    return t('Bulk Upload History')
  }

  render() {
    return (
      <div className="container col-lg-12">
        <div className="text-center bg-inherit">
          <h2 className='page-title'>{this.getPageTitle()}</h2>
        </div>
        {this.getSearchType() && <div>
          <h4 className="text-center page-subtitle">{t('Fill in as many of the following criteria as you can to generate a search.')}</h4>
          <div className="row row-flex">
            <div className="search-box col-md-4">
              <SearchboxComponent {...this.state} searchType={this.props.route.searchType} searchFunction={this.getUploadList.bind(this)} setInsurer={this.setInsurer.bind(this)} />
              <br />
            </div>
          </div>
        </div>}
        {this.state.displayListsData}
        {this.state.displayDetailsData}

        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showModal}
          resetDataOnClose={this.state.resetDataOnClose}
        />

        <LoadingComponent show={this.state.loading} text={t('Loading')} />
      </div>
    );
  }
}

BulkUploadList.displayName = 'BulkUploadList';
export default BulkUploadList;


// WEBPACK FOOTER //
// ./src/components/BulkUploadList.js